import { render, staticRenderFns } from "./File.vue?vue&type=template&id=91a40320&"
import script from "./File.vue?vue&type=script&lang=ts&"
export * from "./File.vue?vue&type=script&lang=ts&"
import style0 from "./File.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports